module.exports = __webpack_public_path__ + "img/iOS@3x.187f90a1.png";